/** @internal */
export const COMPONENT_NAME = 'TerminologyOverlay';
